import { AbstractContentState, useCmsContent } from '@cp-shared-19/frontend-integration';
import { OtherBrandsAvailableModal } from 'cpnl-common';
import { fetchOtherBrandsAvailableModal } from './OtherBrandsAvailableModalSlice';
import { OtherBrandsAvailableModalContentSelector } from './OtherBrandsAvailableModalContentSelector';

export function useOtherBrandsAvailableModal(): AbstractContentState<OtherBrandsAvailableModal> {
    return useCmsContent(fetchOtherBrandsAvailableModal, OtherBrandsAvailableModalContentSelector);
}
